import Filter from '@components/Filter';
import styled from '@emotion/styled';

interface Props {
    sort: 'IssuedAtDesc' | 'ExpiresAtAsc'
    setSort: (v: 'IssuedAtDesc' | 'ExpiresAtAsc') =>void;
}

function CouponFilter({ sort, setSort }:Props) {
  return (
        <Wrapper>
            <Filter title='보기 설정' sort={sort}
                    setSort={setSort}
                    sortItems={[
                      { value: 'IssuedAtDesc', label: '등록순' },
                      { value: 'ExpiresAtAsc', label: '마감 임박순' },
                    ]}
            />
        </Wrapper>
  );
}

const Wrapper = styled.div`
    padding: 12px 16px;
`;

export default CouponFilter;
